// Validation rules for inspection-report photo uploads, shared so the frontend
// drop/picker handlers and the backend upload route enforce the SAME limits.

export const MAX_PHOTO_BYTES = 20 * 1024 * 1024;

// Returns an error message if the file is not an acceptable photo, or null if it
// passes. HEIC/HEIF is allowed by extension because browsers often report an
// empty MIME type for it.
export function photoUploadError(type: string, size: number, filename?: string): string | null {
  const isImage = type.startsWith('image/') || /\.(heic|heif)$/i.test(filename ?? '');
  if (!isImage) return 'Only image files are allowed';
  if (size > MAX_PHOTO_BYTES) return 'File too large. Maximum size is 20MB.';
  return null;
}
